<div class="container">
    <!-- Left Panel -->
    <div class="left-panel">
      <div class="filters">
        <div class="filter-group">
          <label for="workspace">Workspace</label>
          <select id="workspace" [(ngModel)]="selectedWorkspace" (change)="onWorkspaceChange()">
            <option *ngFor="let workspace of workspaces" [value]="workspace">{{ workspace }}</option>
          </select>
        </div>
      </div>
  
      <table class="item-table">
        <thead>
          <tr>
            <th style="width: 70%;">Name</th>
            <th style="width: 30%;">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pipeline of pipelines" (click)="selectPipeline(pipeline)" [class.active]="selected === pipeline">
            <td style="width: 70%;">{{ pipeline.name }}</td>
            <td style="width: 30%;">
              <span class="status-tag" [ngClass]="pipeline.status">{{ pipeline.status }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      
      <!-- No data message -->
      <div *ngIf="!isLoading && filteredPipelines.length === 0" class="no-data-message">
        No data available
      </div>
    </div>
  
    <!-- Right Panel -->
    <div class="right-panel">
      <div class="actions">
        <button class="btn btn-primary" [disabled]="parameterFields.length === 0 || isEditMode || runningItemIds.has(selectedPipeline!.id)" (click)="runPipeline(selectedPipeline!.id)">
          <span class="material-icons">play_arrow</span> Run
        </button>
        <button class="btn btn-outline" [disabled]="!isEditMode || parameterFields.length === 0 || runningItemIds.has(selectedPipeline!.id)" (click)="savePipeline()">
          <span class="material-icons">save</span> Save
        </button>
        <button class="btn btn-outline" [disabled]="!selected || isEditMode || parameterFields.length === 0 || runningItemIds.has(selectedPipeline!.id)" (click)="editPipeline()">
          <span class="material-icons">edit</span> Edit
        </button>
      </div>
  
      <div class="selected-info" *ngIf="selectedPipeline">
        <p><strong>Name:</strong> {{ selectedPipeline.name }}</p>
        <p>
          <strong>Status:</strong>
          <span class="status-tag" [ngClass]="selectedPipeline.status">{{ selectedPipeline.status }}</span>
        </p>
        <div *ngIf="selectedPipeline.status === 'Timeout'" class="timeout-message">
          Operation timed out after 1 hour. Please check the status directly in Microsoft Fabric.
        </div>
        <p><strong>Description:</strong> {{ selectedPipeline.description || 'No description available' }}</p>
      </div>
      <div class="details">
        <p *ngIf="parameterFields.length > 0"><strong>Parameters:</strong></p>
        <div class="input-group" *ngFor="let field of parameterFields">
          <label [for]="'field_' + field.label">{{ field.label }}</label>
          <input [id]="'field_' + field.label" 
                 type="text" 
                 [(ngModel)]="field.value"
                 [disabled]="!isEditMode" />
        </div>
        <div *ngIf="parameterFields.length === 0 && selectedPipeline" class="no-params-message">
          No parameters available
        </div>
      </div>

      <div class="right-panel-overlay" *ngIf="areParamsLoading">
        <mat-spinner diameter="30"></mat-spinner>
      </div>
    </div>
    
    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>

